(function () {
  "use strict";

  var PROXY_BASE = "/apps/wrpg";

  function i18n() {
    var el = document.getElementById("wrpg-blog-i18n");
    if (!el) return { viewsOne: "%count% view", viewsOther: "%count% views", commentsOne: "%count% comment", commentsOther: "%count% comments" };
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return { viewsOne: "%count% view", viewsOther: "%count% views", commentsOne: "%count% comment", commentsOther: "%count% comments" };
    }
  }

  function formatCount(one, other, n) {
    var template = n === 1 ? one : other;
    return String(template || "").replace(/%count%/g, String(n));
  }

  function applyStats(root, stats, labels) {
    var viewsEl = root.querySelector("[data-blog-views]");
    var commentsEl = root.querySelector("[data-blog-comments]");
    if (viewsEl) viewsEl.textContent = formatCount(labels.viewsOne, labels.viewsOther, stats.views || 0);
    if (commentsEl) {
      var count = stats.comments || 0;
      if (count < 1) {
        commentsEl.hidden = true;
        commentsEl.textContent = "";
      } else {
        commentsEl.hidden = false;
        commentsEl.textContent = formatCount(labels.commentsOne, labels.commentsOther, count);
      }
    }
  }

  function collectIds() {
    var ids = [];
    document.querySelectorAll("[data-article-id]").forEach(function (node) {
      var id = node.getAttribute("data-article-id");
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function fillAll(statsMap, labels) {
    document.querySelectorAll("[data-article-id]").forEach(function (node) {
      var id = node.getAttribute("data-article-id");
      applyStats(node, (statsMap && statsMap[id]) || { views: 0, comments: 0 }, labels);
    });
  }

  function recordView(articleId, labels) {
    fetch(PROXY_BASE + "/blog-stats", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ articleId: articleId }),
      credentials: "same-origin",
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data) return;
        document.querySelectorAll('[data-article-id="' + articleId + '"]').forEach(function (node) {
          applyStats(node, data, labels);
        });
      })
      .catch(function () {});
  }

  document.addEventListener("DOMContentLoaded", function () {
    var labels = i18n();
    var ids = collectIds();
    if (!ids.length) return;

    fetch(PROXY_BASE + "/blog-stats?articleIds=" + encodeURIComponent(ids.join(",")))
      .then(function (res) {
        return res.ok ? res.json() : { stats: {} };
      })
      .then(function (data) {
        fillAll(data.stats || {}, labels);
        var viewRoot = document.querySelector("[data-blog-record-view]");
        if (viewRoot) recordView(viewRoot.getAttribute("data-article-id"), labels);
      })
      .catch(function () {});
  });

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-wrpg-copy-link]");
    if (!btn) return;
    var url = btn.getAttribute("data-wrpg-copy-link");
    if (!url || !navigator.clipboard) return;
    navigator.clipboard.writeText(url).then(function () {
      var label = btn.querySelector(".visually-hidden");
      if (label) label.textContent = btn.getAttribute("data-copied") || "Copied";
    });
  });
})();
